import { render } from "./ProjectGroupTable.vue?vue&type=template&id=56ea907a&scoped=true&ts=true"
import script from "./ProjectGroupTable.vue?vue&type=script&lang=ts"
export * from "./ProjectGroupTable.vue?vue&type=script&lang=ts"

import "./ProjectGroupTable.vue?vue&type=style&index=0&id=56ea907a&scoped=true&lang=scss"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56ea907a"]])

export default __exports__